








































import { isEqual } from 'lodash-es'
import axios from '@/common/MyAxios'
import { Component, Vue, Prop, Watch } from 'vue-property-decorator'
import localStorageConfig from '@/common/localstorage-config'
import store, { ILevelInfo, IFieldInfo, IndexingType, StoreType } from '@/store'
import { AxiosResponse } from 'axios'
import * as VCard from 'vuetify/es5/components/VCard'
import * as VTextField from 'vuetify/es5/components/VTextField'
import * as VTextarea from 'vuetify/es5/components/VTextarea'
import * as VBtn from 'vuetify/es5/components/VBtn'
import * as VSelect from 'vuetify/es5/components/VSelect'
import * as VDataTable from 'vuetify/es5/components/VDataTable'
import * as VAlert from 'vuetify/es5/components/VAlert'
import * as VCheckbox from 'vuetify/es5/components/VCheckbox'
import { AbstractView } from '@/views/AbstractView'
class Option<V> {
  constructor(public text: string, public value: V) {}
}
interface ITermInfo {
  term: string
  docFreq: number
  totalTermFreq: number
}
interface ISimilarTermsResults {
  queryMetadata: {}
  result: {
    general: {
      terms: number
      totalDocFreq: number
      totalTermFreq: number
    }
    results: ITermInfo[]
  }
}
@Component({
  localStorage: localStorageConfig,
  components: {
    ...VCard,
    ...VBtn,
    ...VTextField,
    ...VTextarea,
    ...VSelect,
    ...VDataTable,
    ...VAlert,
    ...VCheckbox
  }
})
export default class Terms extends AbstractView {
  protected params = {
    sort: 'TDF',
    sortDirection: 'D',
    offset: 0,
    limit: 20,
    level: '',
    query: '',
    endpoint: ''
  }
  private totalTerms: number = 0
  private totalTermFreq: number = 0
  private totalDocFreq: number = 0
  private results: ITermInfo[] = []
  private headers = [
    { text: 'term', value: 'term' },
    { text: 'total document frequency', value: 'TDF' },
    { text: 'total term frequency', value: 'TTF' }
  ]
  private pagination = {
    sortBy: 'TDF',
    descending: true,
    page: 1,
    rowsPerPage: this.params.limit
  }
  private tsearch = ''
  private get filteredResults() {
    const search = this.tsearch.toLowerCase().trim()
    if (search === '') return this.results
    const props = this.headers.map(h => h.value)
    return this.results.filter(item => item.term.toLowerCase().indexOf(search) !== -1)
  }
  private selected: ITermInfo[] = []
  private separator: string = 'OR'
  private generatedQuery = ''
  @Watch('selected')
  @Watch('separator')
  private onSelect() {
    this.generatedQuery = this.selected.map(s => s.term).join(' ' + this.separator + ' ')
  }
  @Watch('pagination', { deep: true })
  private async search() {
    this.loading = true
    this.error = null
    this.params.sort = this.pagination.sortBy
    this.params.offset = (this.pagination.page - 1) * this.pagination.rowsPerPage
    this.params.limit = this.pagination.rowsPerPage
    this.params.sortDirection = this.pagination.descending ? 'D' : 'A'
    let nq = Object.assign({}, this.$route.query, this.params)
    if (!isEqual(this.$route.query, nq))
      this.$router.push({
        name: 'terms',
        query: nq
      })
    try {
      const response = await axios.get(this.params.endpoint + 'similarTerms', {
        params: this.params,
        auth: this.auths[this.params.endpoint]
      })
      this.request =
        response.config.url + '?pretty&' + response.config.paramsSerializer!(response.config.params)
      this.loading = false
      this.totalTerms = response.data.result.general.terms
      this.totalTermFreq = response.data.result.general.totalTermFreq
      this.totalDocFreq = response.data.result.general.totalDocFreq
      this.results = response.data.result.results
    } catch (error) {
      this.loading = false
      this.error = error
    }
  }
  @Watch('$route.query', { immediate: true })
  private onQueryChanged(): void {
    let nq = Object.assign({}, this.$route.query, this.params)
    if (!isEqual(this.$route.query, nq)) {
      Object.assign(this.params, this.$route.query)
      if (this.params.endpoint && this.params.query) this.search()
    }
  }
  @Watch('indexInfo')
  private onIndexInfoChanged(): void {
    if (this.indexInfo) {
      this.params.level = this.indexInfo.levels.find(
        (l: ILevelInfo) => l.id === this.indexInfo!.defaultLevel
      )!.id
      if (this.params.query) this.search()
    }
  }
}
